module.exports = __webpack_public_path__ + "static/media/digital-dashboard_2.1af7f1d8.svg";